<script>
/**
 * Mixin for filter options in dmp/actions.vue
 * Most computed return default values for the main `actOptions` object.
 * Same behaviour as ./problems.vue.
 */

// Vuex
import { mapState } from 'vuex';
import { FETCH_ACTION_PLANS, FETCH_USERS } from '@/store/action-types';
import { GET_ACTION_PLANS, GET_USERS } from '@/store/mutation-types';

export default {
  computed: {
    actOptions() {
      return [
        {
          key: 'sortTitle',
          component: 'h2',
          options: { class: 'mt5em mb5em basic-sub-title' },
          slots: [{
            component: 'span',
            content: this.$t('message.SORT'),
          }],
        },
        {
          key: 'actionsSortBy',
          component: 'RadioGroup',
          value: this.actOptSortBy,
          options: {
            items: [
              { id: 0, label: this.$t('message.SORT_BY_TITLE') },
              { id: 1, label: this.$t('message.SORT_BY_ADD_IN_ACTION_PLAN_DATE') },
              { id: 2, label: this.$t('message.SORT_BY_DEADLINE') },
              { id: 3, label: this.$t('message.SORT_BY_IMPACT') },
            ],
            sortable: true,
            class: 'mb10',
          },
        },
        {
          key: 'filters',
          component: 'h2',
          options: { class: 'mt10em mb5em basic-sub-title' },
          slots: [{
            component: 'span',
            content: this.$t('message.FILTERS'),
          }],
        },
        {
          key: 'displayedActionPlansTitle',
          component: 'div',
          options: {
            class: 'legend mt10 mb10',
          },
          slots: [{
            component: 'span',
            content: this.$t('message.ACTION_PLANS'),
          }],
        },
        {
          key: 'displayedActionPlans',
          component: 'CheckboxList',
          value: this.actOptDisplayedActionPlans,
          options: {
            items: this.actOptActionPlans,
            labelKey: 'name',
          },
        },
        {
          key: 'actFiltersTitle',
          component: 'div',
          options: {
            class: 'legend mt10 mb10',
          },
          slots: [{
            component: 'span',
            content: this.$t('message.USERS'),
          }],
        },
        {
          key: 'leader',
          component: 'CheckboxList',
          value: this.actOptLeader,
          options: {
            items: this.actOptUserItems,
          },
        },
        {
          key: 'displayOngoinSecuringTitle',
          component: 'div',
          options: {
            class: 'legend mt10',
          },
          slots: [{
            component: 'span',
            content: this.$t('message.DISPLAY_ONGOING_SECURING_ACTIONS'),
          }],
        },
        {
          key: 'displayOngoingSecuringActions',
          component: 'Checkbox',
          value: this.actOptDisplayOngoingSecuringActions,
          options: {
            title: this.$t('message.DISPLAY'),
          },
        },
      ];
    },
    actOptSortBy() {
      if (this.allPageOptions && this.allPageOptions.actionsSortBy) {
        return this.allPageOptions.actionsSortBy;
      }
      return { value: 3, desc: true };
    },
    actOptLeader() {
      if (this.allPageOptions && this.allPageOptions.leader) {
        return this.allPageOptions.leader;
      }
      return this.actOptUserItems.map(user => user.id);
    },
    actOptDisplayOngoingSecuringActions() {
      if (this.allPageOptions && this.allPageOptions.displayOngoingSecuringActions) {
        return this.allPageOptions.displayOngoingSecuringActions;
      }
      return false;
    },
    actOptUserItems() {
      const usersData = this.actOptUsersData || [];
      return [
        { id: 0, label: this.$t('message.UNASSIGNED_FEM') },
        ...usersData.map(user => ({ id: Number(user.id), label: this.$t('fullNameFormat', user) })),
      ];
    },
    /** Array: IDs of the currently displayed action plans */
    actOptDisplayedActionPlans() {
      if (this.allPageOptions && this.allPageOptions.displayedActionPlans) {
        return this.allPageOptions.displayedActionPlans;
      }
      return this.actOptActionPlans.map(ap => ap.id);
    },
    /** If defined, contains all the options above */
    allPageOptions() {
      return null;
    },
    ...mapState({
      actOptUsersData: state => state[GET_USERS.stateKey],
      actOptUsersLoading: state => state[GET_USERS.loadingKey],
      actOptActionPlans: state => state[GET_ACTION_PLANS.stateKey] || [],
      actOptActionPlansLoading: state => state[GET_ACTION_PLANS.loadingKey],
    }),
  },
  created() {
    // Fetch all users
    if (!this.actOptUsersLoading && this.currentTeam && this.currentTeam.id) {
      this.$store.dispatch(FETCH_USERS);
    }
    // Fetch all action plans
    if (!this.actOptActionPlansLoading && this.currentTeam && this.currentTeam.id) {
      this.$store.dispatch(FETCH_ACTION_PLANS);
    }
  },
  methods: {
    /** Create a string formatted as query params with actOptions params */
    actOptQueryParams(options) {
      if (!options) {
        return '';
      }
      let query = '';
      let amp = '';
      if (options.actionsSortBy) {
        query += `actionsSortBy=${options.actionsSortBy.value}&actionsSortDesc=${options.actionsSortBy.desc}`;
        amp = '&';
      }
      if (options.leader) {
        query += `${amp}leader=${options.leader.join(',')}`;
        amp = '&';
      }
      if (options.displayOngoingSecuringActions) {
        query += `${amp}displayOngoingSecuringActions=true`;
        amp = '&';
      }
      if (options.displayedActionPlans) {
        query += `${amp}displayedActionPlans=${options.displayedActionPlans.join(',')}`;
        amp = '&';
      }
      return query;
    },
  },
};
</script>
